/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Expiry Date Fix — fixing group (direct URL only, no menu entry).
 * See docs/dev-tools.md in the backend repo for the full explanation of why this
 * tool exists (safer than editing a GRN — never touches quantities).
 */
import { createContext, useContext, useState, useCallback } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import UrlService from '../../services/UrlService';

const ContextAPI = createContext({});

export function useExpiryFix() {
    return useContext(ContextAPI);
}

export function ExpiryFixProvider({ children }) {
    const axiosPrivate = useAxiosPrivate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const search = useCallback(
        async (codeNo, batchNo) => {
            setLoading(true);
            setErrMsg('');
            try {
                const res = await axiosPrivate.get(UrlService.searchExpiryFixUrl(codeNo, batchNo));
                if (res?.data?.status === 'success') {
                    setRows(res.data.rows || []);
                } else {
                    setRows([]);
                    setErrMsg(res?.data?.msg || 'Search failed.');
                }
            } catch (err) {
                setRows([]);
                setErrMsg(err?.response?.data?.msg || 'Search failed — server not responding.');
            } finally {
                setSearched(true);
                setLoading(false);
            }
        },
        [axiosPrivate]
    );

    // Returns the API response (or throws) so the caller can decide what to do —
    // kept thin on purpose since the confirmation/warning UI lives in the component.
    const updateExpiryDate = useCallback(
        async (id, expireDate) => {
            const res = await axiosPrivate.post(
                UrlService.updateExpiryFixUrl(),
                JSON.stringify({ id, expire_date: expireDate }),
                { headers: { 'Content-Type': 'application/json' } }
            );
            return res?.data;
        },
        [axiosPrivate]
    );

    return (
        <ContextAPI.Provider
            value={{ rows, setRows, loading, searched, errMsg, search, updateExpiryDate }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
